import { render, staticRenderFns } from "./SetDefaultSupplierDialog.vue?vue&type=template&id=605cfcd1&scoped=true&"
import script from "./SetDefaultSupplierDialog.vue?vue&type=script&lang=ts&"
export * from "./SetDefaultSupplierDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cfcd1",
  null
  
)

export default component.exports